import { render, staticRenderFns } from "./tindex3.vue?vue&type=template&id=176cc574&scoped=true&"
import script from "./tindex3.vue?vue&type=script&lang=js&"
export * from "./tindex3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176cc574",
  null
  
)

export default component.exports